import './styles.scoped.css'
import {Outlet} from 'react-router-dom'
import {Header, AdminSidebar} from '../../components'

export default () => {
    return (
        <>
            <Header />
            <AdminSidebar />
            <div className="container">
                <div className="page">
                    <Outlet />
                </div>
            </div>
        </>
    )
}
